import React from 'react'
import ReactGA from 'react-ga'
import PropTypes from 'prop-types'
import moment from 'moment'

import {
  Loader,
  Timeline,
  ModalBookingList,
  ButtonCreate,
  ModalStatus,
  ModalInformation,
} from '../../../components'
import apiService from '../../../reduxs/apiService'
import {
  ROUTE,
  MODAL_STATUS,
  CREATE_DEFAULT,
  CREATE_BOOKING,
  BOOKING_STATUS,
  BOOKING_DETAIL_VIEW,
} from '../../../helpers/constants'
import {
  checkPermission,
  getNearestMinute,
  getCalendarString,
  getLocaleTimeString,
  getPositionBookingCard,
} from '../../../helpers/functions'

import Style from './style'

const oneHourTimeStamp = 1000 * 60 * 60
const oneDayTimeStamp = oneHourTimeStamp * 24
const timezoneOffset = new Date().getTimezoneOffset() * 1000 * 60
class DayAndWeek extends React.Component {
  constructor(props) {
    super(props)
    let selectedDate = new Date(props.year, props.month - 1, props.date, 0, -new Date().getTimezoneOffset())
    if (isNaN(selectedDate.valueOf())) selectedDate = new Date()
    let startDatetime
    let endDatetime
    let startDatetimeHeader
    let endDatetimeHeader
    if (props.view.toLowerCase() === 'week') {
      const currentDay = selectedDate.getDay()
      const selectedTimestamp = selectedDate.valueOf()
      startDatetime = new Date(selectedTimestamp - (oneDayTimeStamp * currentDay))
      endDatetime = new Date(selectedTimestamp + ((6 - currentDay) * oneDayTimeStamp))
      startDatetimeHeader = startDatetime
      endDatetimeHeader = endDatetime
    } else {
      const currentDay = selectedDate.getDay()
      const selectedTImestamp = selectedDate.valueOf()
      startDatetime = selectedDate
      endDatetime = selectedDate
      startDatetimeHeader = new Date(selectedTImestamp - (oneDayTimeStamp * currentDay))
      endDatetimeHeader = new Date(selectedTImestamp + ((6 - currentDay) * oneDayTimeStamp))
    }
    this.initialState = {
      isLoading: true,
      bookingList: [],
      selectedDate: selectedDate,
      startDatetime: startDatetime,
      startDatetimeHeader: startDatetimeHeader,
      endDatetimeHeader: endDatetimeHeader,
      endDatetime: endDatetime,
      scrollToView: false,
      isShowDetail: false,
      view: props.view.toLowerCase(),
      event: null,
      isHiding: true,
      selectedData: null,
      currentCompany: props.userCompany,
      permission: {
        create: checkPermission(props.accountReducer.permission, ROUTE.CALENDAR.ACTION.CREATE)
      },
      isYearAndDay: true,
      position: { x: 0, y: 0 },
      headerName: null,
      descriptionName: null,
      buttonName: null
    }
    this.state = this.initialState

    //GA TrackingId
    ReactGA.initialize("UA-153387162-1")
    ReactGA.pageview("(Day and Week) Calendar Page")
  }

  componentDidMount () {
    const { startDatetimeHeader, endDatetimeHeader } = this.state
    const startDatetime = moment(startDatetimeHeader).format('YYYY-MM-DD 00:00:00')
    const endDatetime = moment(endDatetimeHeader).format('YYYY-MM-DD 23:59:59')
    const params = {
      username: this.props.username,
      startDatetime,
      endDatetime,
      status: '[0,1,2]',
      sorts: JSON.stringify([
        {
          type: 'ASC',
          column: 'startDatetime',
        },
        {
          type: 'DESC',
          column: 'endDatetime',
        },
      ]),
    }

    this.getBookingList(params, () => this.setState({ scrollToView: true, isHiding: false }))
    this.handleGetHolidayList()
  }

  componentDidUpdate () {
    const props = { ...this.props }
    let selectedDate = new Date(props.year, props.month - 1, props.date, 0, -new Date().getTimezoneOffset())
    if (isNaN(selectedDate.valueOf())) selectedDate = new Date()
    if (selectedDate.valueOf() !== this.state.selectedDate.valueOf() || props.view.toLowerCase() !== this.state.view) {
      let startDatetime
      let endDatetime
      let startDatetimeHeader
      let endDatetimeHeader
      if (props.view.toLowerCase() === 'week') {
        const currentDay = selectedDate.getDay()
        const selectedTimestamp = selectedDate.valueOf()
        startDatetime = new Date(selectedTimestamp - (oneDayTimeStamp * currentDay))
        endDatetime = new Date(selectedTimestamp + ((6 - currentDay) * oneDayTimeStamp))
        startDatetimeHeader = startDatetime
        endDatetimeHeader = endDatetime
      } else {
        const currentDay = selectedDate.getDay()
        const selectedTImestamp = selectedDate.valueOf()
        startDatetime = selectedDate
        endDatetime = selectedDate
        startDatetimeHeader = new Date(selectedTImestamp - (oneDayTimeStamp * currentDay))
        endDatetimeHeader = new Date(selectedTImestamp + ((6 - currentDay) * oneDayTimeStamp))
      }
      this.initialState = {
        isLoading: true,
        bookingList: [],
        selectedDate: selectedDate,
        startDatetime: startDatetime,
        startDatetimeHeader: startDatetimeHeader,
        endDatetimeHeader: endDatetimeHeader,
        endDatetime: endDatetime,
        scrollToView: false,
        isShowDetail: false,
        event: null,
        view: props.view.toLowerCase(),
        selectedData: null
      }
      this.setState(this.initialState, () => {
        const { startDatetimeHeader, endDatetimeHeader } = this.state
        const startDatetime = moment(startDatetimeHeader).format('YYYY-MM-DD 00:00:00')
        const endDatetime = moment(endDatetimeHeader).format('YYYY-MM-DD 23:59:59')
        const params = {
          username: this.props.username,
          startDatetime,
          endDatetime,
          status: '[0,1,2]',
          sorts: JSON.stringify([
            {
              type: 'ASC',
              column: 'startDatetime',
            },
            {
              type: 'DESC',
              column: 'endDatetime',
            },
          ]),
        }

        this.getBookingList(params, () => this.setState({ scrollToView: false }))
        this.handleGetHolidayList()
      })
    } else if (this.state.currentCompany !== this.props.userCompany) {
      this.handleGetHolidayList()
    }
  }

  getTotalDayInMonth (month = (new Date()).getMonth(), year = (new Date()).getFullYear()) {
    return 32 - (new Date(year, month, 32)).getDate()
  }

  objGetParams = () => {
    const month = this.props.match.params.month
    const year = this.props.match.params.year
    const {
      trashed,
      limit,
      ownerName,
    } = this.state
    const lastDayOfThisMonth = this.getTotalDayInMonth(month - 1, year)
    const statedate = new Date(year, month - 1, -6)
    const enddate = new Date(year, month - 1, lastDayOfThisMonth + 6)
    const startTime = `${moment(statedate).format('YYYY-MM-DD')} 00:00:00`
    const endTime = `${moment(enddate).format('YYYY-MM-DD')} 23:59:59`

    return {
      trashed,
      limit,
      username: ownerName,
      companyId: this.props.accountReducer.user.companyId,
      isIncludeChildBooking: false,
      startDatetime: startTime,
      endDatetime: endTime,
      status: JSON.stringify([
        BOOKING_STATUS.COMPLETED,
        BOOKING_STATUS.IN_USE,
        BOOKING_STATUS.WAITING,
      ]),
      sorts: JSON.stringify([
        {
          type: 'ASC',
          column: 'startDatetime',
        }
      ]),
    }
  }

  handleGetHolidayList = () => {
    const { selectedDate } = this.state
    const date = new Date(selectedDate)
    const dateEndOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
    const startDatetimeGetHoliday = moment(date).format('YYYY-MM-01 00:00:00')
    const endDatetimeGetHoliday = moment(date).format(`YYYY-MM-${dateEndOfMonth} 23:59:59`)

    this.props.getListHoliday({
      startDatetime: startDatetimeGetHoliday,
      endDatetime: endDatetimeGetHoliday,
      companyId: this.state.currentCompany,
      limit: 999
    })
  }

  goBack () {
    this.props.history.goBack()
  }

  initDatetime (selectedDate) {
    const minuteStep = this.props.minuteStep
    let minute = getNearestMinute(selectedDate.getMinutes(), minuteStep, 1)
    let hour = selectedDate.getHours()
    let now = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), hour, minute)
    if (minute >= 60) {
      minute = 0
      hour = hour + 1
      if (hour >= 24) {
        now = null
      }
    }
    if (now !== null) now = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), hour, minute)
    return now
  }

  handleMoveTimeline (data) {
    const selectedDate = new Date(Math.floor((data.startDatetime.valueOf()) / oneDayTimeStamp) * oneDayTimeStamp)
    const selectedEndTime = new Date(data.endDatetime.valueOf() + timezoneOffset)
    const selectedStartTime = new Date(data.startDatetime.valueOf() + timezoneOffset)
    const dateString = [selectedDate.getFullYear(), (selectedDate.getMonth() + 1).toString().padStart(2, 0), selectedDate.getDate().toString().padStart(2, 0)].join('-')
    const startTimeString = [selectedStartTime.getHours().toString().padStart(2, 0), selectedStartTime.getMinutes().toString().padStart(2, 0), '00'].join(':')
    const endTimeString = [selectedEndTime.getHours().toString().padStart(2, 0), selectedEndTime.getMinutes().toString().padStart(2, 0), '00'].join(':')

    const params = {
      bookingId: data.id,
      startDatetime: [dateString, startTimeString].join(' '),
      endDatetime: [dateString, endTimeString].join(' ')
    }
    let index = -1
    for (const booking of this.state.bookingList) {
      if (booking.id === data.id) {
        index = index + 1
        break
      }
      index = index + 1
    }
    this.tmpBookingList = this.state.bookingList.slice()
    const newBookingList = this.state.bookingList.slice()
    if (index >= 0) {
      newBookingList.splice(index, 1)
    }
    this.setState({
      bookingList: newBookingList.concat([{
        ...data,
        isActive: true
      }])
    })
    this.updateBooking(params, () => {
      const { startDatetime, endDatetime } = this.state
      const startDateString = [startDatetime.getFullYear(), (startDatetime.getMonth() + 1).toString().padStart(2, 0), startDatetime.getDate().toString().padStart(2, 0)].join('-')
      const endDateString = [endDatetime.getFullYear(), (endDatetime.getMonth() + 1).toString().padStart(2, 0), endDatetime.getDate().toString().padStart(2, 0)].join('-')
      const startTimeString = ['00', '00', '00'].join(':')
      const endTimeString = ['23', '59', '59'].join(':')
      const paramss = {
        username: this.props.username,
        startDatetime: [startDateString, startTimeString].join(' '),
        endDatetime: [endDateString, endTimeString].join(' '),
        status: JSON.stringify([
          BOOKING_STATUS.COMPLETED,
          BOOKING_STATUS.IN_USE,
          BOOKING_STATUS.WAITING,
        ]),
        sorts: JSON.stringify([
          {
            type: 'ASC',
            column: 'startDatetime'
          },
          {
            type: 'DESC',
            column: 'endDatetime'
          }
        ]),
      }
      this.getBookingList(paramss)
    }, () => {
      this.setState({ bookingList: this.tmpBookingList })
      this.tmpBookingList = null
    })
  }

  handleClickTimeline (timestamp) {
    const { permission } = this.state
    const endDatetimeOffset = oneHourTimeStamp
    const selectedDate = new Date(timestamp + timezoneOffset)
    const selectedEndTime = this.initDatetime(new Date(timestamp + endDatetimeOffset + timezoneOffset))
    const dateString = [selectedDate.getFullYear(), (selectedDate.getMonth() + 1).toString().padStart(2, 0), selectedDate.getDate().toString().padStart(2, 0)].join('-')
    const startTimeString = [selectedDate.getHours().toString().padStart(2, 0), selectedDate.getMinutes().toString().padStart(2, 0)].join(':')
    const endTimeString = [selectedEndTime.getHours().toString().padStart(2, 0), selectedEndTime.getMinutes().toString().padStart(2, 0)].join(':')

    if (permission.create) {
      this.props.history.push(`${ROUTE.BOOKING.LINK}?date=${dateString}&startTime=${startTimeString}&endTime=${endTimeString}&from=calendar_${this.props.match.params.view || 'week'}`)
    }
  }

  handleClickHeader (timestamp) {
    const selectedDate = new Date(timestamp + timezoneOffset)
    this.props.history.push(`${ROUTE.CALENDAR.LINK}/day/${selectedDate.getFullYear()}/${(selectedDate.getMonth() + 1).toString().padStart(2, 0)}/${selectedDate.getDate().toString().padStart(2, 0)}`)
  }

  handleClickEvent (event, data) {
    const { modalAction, modalReducer, language } = this.props
    const { isOpenBookingDetailModal } = modalReducer

    const startDatetime = new Date(data.startDatetime.valueOf() + timezoneOffset)
    const endDatetime = new Date(data.endDatetime.valueOf() + timezoneOffset)

    if (isOpenBookingDetailModal) {
      modalAction.closeBookingMoreDetailModal()
    } else {
      modalAction.openBookingDetailModal()
    }

    this.setState({
      position: getPositionBookingCard({ event, isMore: false, isYear: false }),
      date: new Date(),
      selectedData: {
        ...data,
        id: data.id,
        title: data.projectName,
        day: getCalendarString(startDatetime, language),
        location: data.roomName,
        time: `${getLocaleTimeString(startDatetime)} - ${getLocaleTimeString(endDatetime)}`,
        timeStart: `${getLocaleTimeString(startDatetime)}`,
        detail: data.owner,
        status: data.status,
        description: data.description || CREATE_BOOKING.NO_DATA[language],
      },
      scrollToView: false,
    })
  }

  updateBooking (param, func, funcError) {
    this.setState({
      isLoading: true,
      scrollToView: false
    })
    apiService.post('rest/v1/update_booking', param).then((res) => {
      if (res.status) {
        func()
      } else if (!res.status) {
        funcError()
        this.setState({
          isLoading: false
        })
        this.props.openModalStatus(res)
      } else {
        funcError()
        this.setState({
          isLoading: false
        })
        console.log('ERROR ACTION createBuilding', res)
      }
    })
  }

  deleteBooking (deletedReason) {
    this.setState({
      isLoading: true,
      scrollToView: false,
      isShowDetail: false,
      selectedData: null,
      event: null
    })
    apiService.post('rest/v1/delete_booking', {
      bookingId: this.state.selectedData.id,
      deletedReason: deletedReason
    }).then((res) => {
      this.props.closeModalConfirm()
      if (res.status) {
        const { startDatetime, endDatetime } = this.state
        const startDateString = [startDatetime.getFullYear(), (startDatetime.getMonth() + 1).toString().padStart(2, 0), startDatetime.getDate().toString().padStart(2, 0)].join('-')
        const endDateString = [endDatetime.getFullYear(), (endDatetime.getMonth() + 1).toString().padStart(2, 0), endDatetime.getDate().toString().padStart(2, 0)].join('-')
        const startTimeString = ['00', '00', '00'].join(':')
        const endTimeString = ['23', '59', '59'].join(':')
        const params = {
          username: this.props.username,
          startDatetime: [startDateString, startTimeString].join(' '),
          endDatetime: [endDateString, endTimeString].join(' '),
          status: JSON.stringify([
            BOOKING_STATUS.COMPLETED,
            BOOKING_STATUS.IN_USE,
            BOOKING_STATUS.WAITING,
          ]),
          sorts: JSON.stringify([
            {
              type: 'ASC',
              column: 'startDatetime'
            },
            {
              type: 'DESC',
              column: 'endDatetime'
            }
          ]),
        }
        this.getBookingList(params, () => this.setState({ scrollToView: false }))
      } else if (!res.status) {
        this.setState({
          isLoading: false
        })
        this.props.openModalStatus(res)
      } else {
        this.setState({
          isLoading: false
        })
        console.log('ERROR ACTION createBuilding', res)
      }
    })
  }

  getBookingList (param, func) {
    param = {
      ...param,
      username: this.props.username,
      companyId: this.props.accountReducer.user.companyId,
      isIncludeChildBooking: false,
    }
    this.setState({ isLoading: true })
    return apiService.get('rest/v2/getlist_booking', { ...param, showPrivateSubject: true }).then((res) => {
      this.setState({ isLoading: false })
      if (res.status) {
        this.setState({ bookingList: res.data.list })
        if (func) func()
      } else if (!res.status) {
        this.setState({ bookingList: [] })
        this.props.openModalStatus(res)
      } else {
        this.setState({ bookingList: [] })
        console.log('ERROR ACTION getListAllBooking2', res)
      }
    })
  }

  goToCreateBooking () {
    const selectedDate = this.state.selectedDate
    const dateString = [selectedDate.getFullYear(), (selectedDate.getMonth() + 1).toString().padStart(2, 0), selectedDate.getDate().toString().padStart(2, 0)].join('-')

    this.props.history.push(`${ROUTE.BOOKING.LINK}?date=${dateString}&from=calendar_${this.props.match.params.view || 'week'}`)
    this.trackingCreateButton()
  }

  openModalInformation = (event, dataInfo) => {
    event.stopPropagation()
    event.preventDefault()
    const {
      modalAction
    } = this.props
    this.setState({
      headerName: dataInfo.headerName,
      descriptionName: dataInfo.descriptionName,
      buttonName: dataInfo.buttonName,
    }, () => {
      modalAction.openModalInformation()
    })
  }

  openModalConfirm = () => {
    const {
      modalAction
    } = this.props
    modalAction.openModalConfirm()
  }

  trackingCreateButton () {
    ReactGA.event({
      category: "Day and Week Calendar",
      action: "Create_Button",
    })
  }

  closeModal = () => {
    const { modalAction } = this.props
    modalAction.closeModalInformation()
    modalAction.closeBookingDetailModal()
    modalAction.closeBookingMoreDetailModal()
  }

  render () {
    const props = Object.assign({}, this.props)
    const state = Object.assign({}, this.state)
    const language = props.language
    const { colorTheme } = props.settingReducer.settingTheme

    const { selectedData, isYearAndDay, position, headerName, descriptionName, buttonName } = this.state

    const { 
      modalReducer,
      bookingcalendarAction,
      modalAction,
    } = this.props
    const { isOpenBookingDetailModal } = modalReducer

    return (
      <Style>
        <Timeline
          isMoveable
          isResizeable
          colorTheme={colorTheme}
          bookingList={state.bookingList}
          startDatetimeHeader={state.startDatetimeHeader}
          startDatetimeContent={state.startDatetime}
          endDatetimeHeader={state.endDatetimeHeader}
          endDatetimeContent={state.endDatetime}
          selectedDate={state.selectedDate}
          username={props.username}
          handleEdit={(data) => this.handleMoveTimeline(data)}
          handleClickTimeline={(stmp) => this.handleClickTimeline(stmp)}
          scrollToView={state.scrollToView}
          handleClickHeader={(stmp) => this.handleClickHeader(stmp)}
          handleClickEvent={(event, data) => this.handleClickEvent(event, data)}
          holidayList={props.holidayList.map((holiday) => new Date(holiday.date).valueOf())}
          holidayListName={props.holidayList}
          minuteStep={props.minuteStep}
          startOperatingTime={props.startOperatingTime}
          endOperatingTime={props.endOperatingTime}
          language={language}
          view={state.view}
          history={props.history}
        />
        {(props.modalStatus && !props.modalStatus.status) &&
          <ModalStatus
            language={language}
            code={props.modalStatus.code}
            action={props.modalStatus.status
              ? `${CREATE_DEFAULT.EDIT[language]}${MODAL_STATUS.COMPLELTE[language]}`
              : MODAL_STATUS.WARNING[language]}
            text={props.modalStatus.status
              ? MODAL_STATUS.SUCCESS[language]
              : props.modalStatus.description}
            status={props.modalStatus.status}
            onClick={props.closeModalStatus}
            colorTheme={colorTheme}
          />}
        {state.isLoading
          ? <Loader colorTheme={colorTheme} />
          : null}
        {state.permission.create &&
          <ButtonCreate
            onClick={() => { this.goToCreateBooking() }}
            settingReducer={props.settingReducer}
          />
        }
        {isOpenBookingDetailModal && selectedData
          ? (
            <ModalBookingList
              bookings={[{ ...selectedData, bookingId: selectedData.id }]}
              colorTheme={props.settingReducer.settingTheme.colorTheme}
              history={props.history}
              event={state.event}
              typeModal={BOOKING_DETAIL_VIEW.BOOKING_VIEW}
              position={position}
              language={props.language}
              closeModal={this.closeModal}
              deleteBooking={() => {
                props.openModalConfirm()
              }}
              permission={props.accountReducer.permission}
              isFloorPlan={false}
              modalReducer={modalReducer}
              modalAction={modalAction}
              bookingcalendarAction={bookingcalendarAction}
              nameModal={selectedData.projectName}
              objGetParams={this.objGetParams}
              isYearAndDay={isYearAndDay}
              onClickInformation={(event, dataInfo) => this.openModalInformation(event, dataInfo)}
              onClickConfirm={() => this.openModalConfirm()}
            />)
          : null}

          {modalReducer.isOpenModalInformation && <ModalInformation
            headerName={headerName}
            colorTheme={colorTheme}
            descriptionName={descriptionName}
            buttonName={buttonName}
            onClick={this.closeModal}
          />}
      </Style>
    )
  }
}

DayAndWeek.propTypes = {
  openModalStatus: PropTypes.func,
  closeModalStatus: PropTypes.func,
  openModalConfirm: PropTypes.func,
  closeModalConfirm: PropTypes.func,
  date: PropTypes.number,
  month: PropTypes.number,
  year: PropTypes.number,
  language: PropTypes.string,
  username: PropTypes.string,
  minuteStep: PropTypes.number,
  startOperatingTime: PropTypes.string,
  endOperatingTime: PropTypes.string
}

export default DayAndWeek
